import axios from 'axios';
import { API_URL } from '@/config/api';
import { betterAuthEnabled, getBetterAuthClient, checkAuthResult } from './betterAuthClient';

const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

export const userService = {
    async register(model) {
        if (betterAuthEnabled) {
            checkAuthResult(await getBetterAuthClient().signUp.email({
                name: `${model.first_name} ${model.last_name}`, firstName: model.first_name, lastName: model.last_name,
                email: model.email, password: model.password, callbackURL: `${window.location.origin}/#/auth-callback`,
            }));
            return { status: 202 };
        }
        return axiosInstance.post('/register', { user: model });
    },

    confirmEmail(token) {
        return axiosInstance.post('/email-verification/confirm', { token });
    },

    async resendVerification(email) {
        if (betterAuthEnabled) return checkAuthResult(await getBetterAuthClient().sendVerificationEmail({ email, callbackURL: `${window.location.origin}/#/auth-callback` }));
        return axiosInstance.post('/email-verification/resend', { email });
    },

    getProfile() {
        return axiosInstance.get('/profile')
            .then((res) => res.data)
            .catch((err) => { throw err; });
    },

        updateProfile(payload) {
            return axiosInstance.post('/profile', payload)
            .then((res) => res.data)
            .catch((err) => { throw err; });
    },

    changePassword(current_password, new_password) {
            return axiosInstance.post('/profile/password', { current_password, new_password })
            .then((res) => res.data)
            .catch((err) => { throw err; });
    },

    updateAvatar(file) {
        return axiosInstance.post('/profile/avatar', file, {
            headers: { 'Content-Type': 'text/plain' },
        }).then((res) => res.data);
    },

    deleteAvatar() {
        return axiosInstance.delete('/profile/avatar');
    },
};  
